// The customer comes from the token and the server ties the review to their
// latest order containing the product, so neither author nor order is sent.
// body is optional: a star rating on its own is a review.
export const GQL_SUBMIT_REVIEW = `
    mutation SubmitReview(
        $itemId: String!,
        $rating: Int!,
        $body: String,
        $title: String
    ) {
        submitReview (
            itemId: $itemId,
            rating: $rating,
            body: $body,
            title: $title
        )
    }
`;

// The post-delivery popup's order and the products the customer can review
// now, or null when there's nothing to ask (including while snoozed).
export const GQL_REVIEW_PROMPT = `
    query ReviewPrompt {
        reviewPrompt {
            orderId
            fulfillmentType
            invoicedAt
            items {
                itemId
                itemName
            }
        }
    }
`;

// Maybe later, close, or a submit leaving products unrated. The server hides
// the popup for 3 days, then asks about what's left, and stops after a second
// snooze of the same order.
export const GQL_SNOOZE_REVIEW_PROMPT = `
    mutation SnoozeReviewPrompt($orderId: String!) {
        snoozeReviewPrompt(orderId: $orderId)
    }
`;

// Names and images for the items of an order. Including discontinued items so a
// product delisted since delivery can still be rated.
export const GQL_GET_ORDER_FEEDBACK_PRODUCTS = `
    query OrderFeedbackProducts($itemIds: [String!]!, $size: Int) {
        searchProductsByItemIdIncludingDiscontinued(
            itemIds: $itemIds,
            size: $size,
            includeNonPublicItems: true
        ) {
            results {
                itemId
                itemName
                imageLinks
            }
        }
    }
`;
